import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/base/services/base.service';

@Injectable()
export class PreProjetoExportarService extends BaseService<any> {
  constructor(public http: HttpClient) {
    super(http);
  }

  public getProcess() : Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/pre-projeto/pre-projeto-exportar';
  }

  
}
